import { Layout } from "antd";
import SchedulingBody from "../../components/scheduling/SchedulingBody";

const Scheduling = () => {
  return (
    <>
      <Layout style={{ minHeight: "100vh", paddingLeft: "20px", paddingRight: "20px" }} className="max-w-6xl w-full mx-auto">
        <SchedulingBody />
      </Layout>
    </>
  );
};

export default Scheduling;
